import { OvlAddScreen } from "../../../../../../_ovlclient/src/global/globals"
import { ScreenSymbolPC } from "../../screens/spcsymbolpc/symbolpc"
import { ScreenSymbolPCEndUser } from "../../screens/spcsymbolpcenduser/symbolpcenduser"

export const SPCSymbolPC_Init = () => {
  OvlAddScreen(ScreenSymbolPC, "SPCSymbolPC")
  OvlAddScreen(ScreenSymbolPCEndUser, "SPCSymbolPCEndUser")
}
